<div class="modal-header">
    <h4 class="modal-title" id="modal-title">Cancel Auto-Renewal</h4>
    <button type="button" class="close" aria-describedby="modal-title" (click)="modal.close('close')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>
        <strong>Are you sure you want to cancel?</strong>
    </p>
    <p>
        Your benefits will stay active until the end of the billing period. Once cancelled, you'll need to enter your
        payment information again if you want to re-activate your sponsorship.
    </p>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-outline-secondary"
        ngbAutofocus
        (click)="modal.close('close')"
        [disabled]="working"
    >
        Stay subscribed
    </button>
    <button type="button" class="btn btn-danger" (click)="cancel()" [disabled]="working">
        <span *ngIf="working"><i class="fas fa-spin fa-spinner"></i> Please wait...</span>
        <span *ngIf="!working">Cancel now</span>
    </button>
</div>
